export default __webpack_public_path__ + "static/media/slide1.1ab05949.jpg";